/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { QuestionType } from './questionType';
import type { ContentStudioQuestionOptions } from './contentStudioQuestionOptions';
import type { ContentStudioQuestionHelpText } from './contentStudioQuestionHelpText';

/**
 * A question asked to the user during the workflow.
 */
export interface ContentStudioQuestion {
  id: string;
  text: string;
  type: QuestionType;
  options?: ContentStudioQuestionOptions;
  helpText?: ContentStudioQuestionHelpText;
}
